import axios from "axios";
import { commonRequest } from "../../services/ApiCall";
import { Helpers } from "../../services/Helpers";


export const ReportServices = {
    fetchWeeklyOperationsReport: async (data) => {
        const queryParams = new URLSearchParams();
        queryParams.append('startDate', data.startDate);
        queryParams.append('endDate', data.endDate);

        return await commonRequest(
            "GET",
            `${Helpers.URL()}/api/admin/reports/weekly-operations?${queryParams.toString()}`,
            {},
            Helpers.token()
        );
    },
    downloadWeeklyOperationsReportPdf: async (data) => {
        const queryParams = new URLSearchParams();
        queryParams.append('startDate', data.startDate);
        queryParams.append('endDate', data.endDate);

        const response = await axios.get(
            `${Helpers.URL()}/api/admin/reports/weekly-operations/pdf?${queryParams.toString()}`,
            {
                headers: {
                    Authorization: `Bearer ${Helpers.token()}`,
                },
                responseType: 'blob',
            }
        );

        return response.data;
    },
    fetchExpertPayoutRecords: async (data) => {
        const queryParams = new URLSearchParams();

        // Basic pagination and sorting parameters
        queryParams.append('startDate', data.startDate);
        queryParams.append('endDate', data.endDate);    

        const response = await commonRequest("GET",  `${Helpers.URL()}/api/admin/reports/expert/payout?${queryParams.toString()}`,{}, Helpers.token());
        return response;
    }
}
